var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ConstructionTaskForm',{ref:"form",attrs:{"default-values":_vm.defaultValues},on:{"submit":_vm.goListPage,"cancel":_vm.goListPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }